module.exports = __webpack_public_path__ + "img/抽奖标题.233816f4.png";